























# import settings from '@/settings'
import interviews_table from '@/components/tables/interviews_table'
import interview_files_modal from '@/components/interview_files_modal'
import m from '@/graphql/mutation'
import n from '@/utils/notifications'

export default {
    name: 'company_interviews_history'

    components: { interviews_table, interview_files_modal }

    data: ()->
        reason_dialog_visible: false
        files_dialog_visible: false
        reload: false
        interview: {}
        errors: {}

    methods:
        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        open_confirm: (interview)->
            @reason_dialog_visible = true
            @interview = interview
            # console.log 'OPEN CONFIRM'
            return

        cancel: ()->
            @reason_dialog_visible = false
            @reload = !@reload
            @errors = {}
            return

        open_file_modal: (interview)->
            # console.log "CIH -> OPEN"
            @interview = interview
            @files_dialog_visible = true
            return

        close_file_modal: ()->
            # console.log "CIH -> CLOSE"
            @files_dialog_visible = false
            @reload = !@reload
            return

        pre_save: ()->
            @save(@interview)
            return

        save: (interview)->
            # console.log "SAVE INTERVIEW", interview
            self = @
            m.run('save_interview', [interview, 'company'])
            .then (resp)->
                if resp.body.data.interview_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.interview_form_mutation.errors.length > 0
                    # console.log "ERRORS", resp.body.data.interview_form_mutation.errors
                    self.errors = resp.body.data.interview_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    self.errors = {}
                    n.success()
                    self.reason_dialog_visible = false
                    self.interview = {}
                    self.reload = !self.reload
            .catch (resp)->
                n.catch_error(resp, "company_interviews_history: save()")
}
